import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workorder-detail',
  templateUrl: './workorder-detail.component.html',
  styleUrls: ['./workorder-detail.component.scss']
})
export class WorkorderDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
